import { compose } from '@beef/redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { currentCardProduct, selectIsRenderRecentlyBlock, withCardsProductsMapper } from "../../../../../store/slices/search/selectors";
import { CellCard, CommonBlock } from "../../CommonBlock";
import { TITLES_BLOCK } from "../../../utils/constants";
import { withMetric } from "../../../../../metric";
import { EMetricBlockName } from "../../../../../types";
import { withAnalyticsCard } from "../../../hocs/withAnalyticsCard";
export var RecommendationBlock = compose(connect(function (state, props) {
  return {
    title: TITLES_BLOCK.recently,
    shouldRender: props.shouldRender && selectIsRenderRecentlyBlock(state)
  };
}), withMetric({
  asChild: true,
  data: JSON.stringify({
    block_name: EMetricBlockName.recommendations
  }),
  events: {
    headerMetric: ['handleViewSearchBlock']
  },
  mode: 'viewport',
  once: true
}), withCardsProductsMapper, withRenderFlag)(CommonBlock);
export var RecommendationCard = compose(connect(function (state) {
  return {
    item: currentCardProduct(state)
  };
}), withAnalyticsCard({
  block_name: EMetricBlockName.recommendations
}))(CellCard);